import { Injectable } from '@angular/core';
import { BaseService } from '../abstracts/base.service';
import { AssessmentDocumentShareModel } from '../models/assessment-document-share.model';
import { AssessmentTemplateModel } from '../models/assessment-template.model';
import { ResultModel } from '../models/result.model';

@Injectable({
  providedIn: 'root'
})
export class AssessmentService extends BaseService {

   listAllForSelect(params?: any) {
    var query = this.getQueryString(params);
    if(query)
      return this.httpClient.get<ResultModel<AssessmentTemplateModel[]>>(this.getApiUrl(`assessments?${query}`));
    else
      return this.httpClient.get<ResultModel<AssessmentTemplateModel[]>>(this.getApiUrl('assessments'));
  }

  listAll(formData:FormData) {
    return this.httpClient.post<ResultModel<AssessmentTemplateModel[]>>(this.getApiUrl('assessments/list'), formData);
  }

  create(assessmenttemplate: AssessmentTemplateModel) {
    return this.httpClient.post<ResultModel>(this.getApiUrl('assessments'), assessmenttemplate);
  }

  update(assessmenttemplate: AssessmentTemplateModel) {
    return this.httpClient.put(this.getApiUrl('assessments'), assessmenttemplate);
  }

  get(id:string) {
    return this.httpClient.get<{ AssessmentTemplate: AssessmentTemplateModel }>(this.getApiUrl('assessments/' + id));
  }

  delete(id:string) {
    return this.httpClient.delete<ResultModel>(this.getApiUrl('assessments/' + id));
  }

  deleteShare(id:string) {
    return this.httpClient.delete<ResultModel>(this.getApiUrl('assessments/share/' + id));
  }
  listShareAll(formData: FormData){
    
    // var queryParams = {
    //   pClassID: ClassID,
    //   pTrainingID: TrainingID,
    // }

    // let queryString = this.getQueryString(queryParams);

    // if(queryString){
    //   queryString = '?' + queryString;
    // }

    return this.httpClient.post<ResultModel>(this.getApiUrl('assessments/document-share/listshare'), formData);
     
  }

  createDocumentShare(documentModel: AssessmentDocumentShareModel) {
    return this.httpClient.post<ResultModel>(this.getApiUrl('assessments/document-share/material-upload'), documentModel);
  }

  updateClassMaterial(documentModel: AssessmentDocumentShareModel[],studentID:any) {
    return this.httpClient.post<ResultModel>(this.getApiUrl(`assessments/document-share/class-document-upload/${studentID}`), documentModel);
  }

  getListMateryal(classID:any, studentID:any) {
    return this.httpClient.get<ResultModel<AssessmentDocumentShareModel[]>>(this.getApiUrl(`assessments/document-share/list-metaryal/${classID}/student/${studentID}`));

  }

}
